import { memo } from "react";
import { css } from "../../../../../styled-system/css";

export const Heading = memo(({ children }: { children: React.ReactNode }) => (
  <h2
    className={css({
      fontSize: "22px",
      fontWeight: "400",
      color: "text.primary",
      lineHeight: "1.35",
    })}
  >
    {children}
  </h2>
));
